export default __webpack_public_path__ + "locales/sr-Cyrl-RS/JavascriptSdk.json?hash=0d37e942a16c5e7178f268aef75edf5f";